import posthog from '../posthogClient';

/**
 * Shared PostHog capture for Connections / workspace events (Phase 6).
 * Same gate pattern as BSI / onboarding helpers.
 *
 * Workspace menu events (Step 1 sidebar):
 * - workspace_renamed { workspace_id, source: 'sidebar' }
 * - workspace_duplicated { workspace_id, source_workspace_id, include_baskets, source }
 * - workspace_deleted { workspace_id, basket_count, topic_count, was_open, source }
 * - account_menu_item_tapped { item: 'upgrade' | 'tour' | 'sign_out', source }
 * - workspace_template_imported { ..., source }
 *
 * Phase 14 — home gate (HomeGate):
 * - legacy_picker_url_opened { has_workspaces }
 * - home_workspace_auto_created { reason: 'no_workspaces' | 'last_deleted' }
 *
 * Connections item / basket management:
 * - topic_deleted { topic_id, basket_id?, workspace_id, source: 'inspect_panel' }
 * - basket_deleted { basket_id, workspace_id, topic_count }
 * - basket_renamed { basket_id, workspace_id, source: 'menu' }
 * - basket_add_item_started { basket_id, workspace_id, source: 'empty_state' | 'menu' }
 *
 * Premium gating:
 * - upgrade_modal_opened { source }
 * - mastery_filter_locked_tapped { bucket }
 * - checkout_started { source, tier }
 *
 * Mastery filter:
 * - mastery_filter_applied { bucket }
 * - mastery_filter_cleared { source: 'chip' | 'empty_state' | 'sidebar' }
 *
 * Template locking:
 * - locked_item_opened { topic_id, basket_id? }
 * - workspace_template_imported { ..., locked_baskets_count, locked_items_count }
 *
 * Basket row (default home Baskets strip):
 * - basket_row_shown { workspace_id, first_basket_id, row_size }
 * - basket_row_tile_opened { basket_id, position }
 *
 * Basket card recall advance:
 * - recall_advanced { basket_id, from_topic_id, to_topic_id }
 * - basket_round_finished { basket_id, topic_count }
 *
 * Due session:
 * - due_for_review_session_completed { workspace_id, total, recalled_count, not_recalled_count, remaining }
 * - due_round_next_clicked { kind: 'retry' | 'keep_going', count }
 *
 * Exam date:
 * - exam_date_set { source: 'create' | 'edit', days_until }
 * - exam_date_skipped { source: 'create' }
 * - exam_date_removed
 *
 * Create item preview:
 * - create_item_preview_opened { source: 'summary_row' | 'example' }
 *
 * Empty workspace:
 * - empty_state_viewed { workspace_id, basket_count }
 * - empty_state_add_topic_clicked { workspace_id, had_text }
 */
export const captureConnectionsEvent = (eventName, properties = {}) => {
  if (!process.env.REACT_APP_POSTHOG_KEY) return;

  try {
    posthog.capture(eventName, properties);
  } catch (error) {
    console.warn('PostHog capture failed:', eventName, error);
  }
};
